/**
 * Resolves which Smart CMS site to render, preferring a `?site=` URL override
 * over the build-time default.
 *
 * Not an access control boundary: any id in the URL will be rendered.
 */

const PARAM = "site"

/** Site ids are ULIDs. Validated to keep junk out of the request path. */
const SITE_ID = /^[0-9A-HJKMNP-TV-Z]{26}$/i

/** The `?site=` override, or "" when absent, malformed, or off-browser. */
export function previewSiteId(): string {
  if (typeof window === "undefined") return ""

  let value: string | null = null
  try {
    value = new URLSearchParams(window.location.search).get(PARAM)
  } catch (error) {
    return ""
  }

  if (!value) return ""

  const id = value.trim()
  if (!SITE_ID.test(id)) {
    console.log(`[smartcms] ignoring malformed ?${PARAM}= value`)
    return ""
  }

  return id
}

export function resolveSiteId(fallback?: string | null): string {
  return previewSiteId() || (fallback ?? "").trim()
}
